import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { UserRegistrationModel, User } from '../models/user.model';
import { Post } from '../post-user/post-user.component';
import { environment } from '../../environments/environment';

@Injectable()
export class RegistrationService {
  //endpoint = 'http://localhost:58830/api/User/';
  endpoint = environment.apiEndpoint + '/User/';

  constructor(private http: HttpClient) {}

  registerUser(registerUserModel: UserRegistrationModel): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = registerUserModel;
    return this.http.post<UserRegistrationModel>(this.endpoint + 'RegisterUser', body, {
      headers,
      observe: 'response'
    });
  }

  addUserLocations(newLocationIds: number[]): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = newLocationIds;
    return this.http.post<number[]>(this.endpoint + 'AddUserLocations', body, { headers, observe: 'response' });
  }

  updateUserReportCategories(newUserReportCategoryIds: number[]): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = newUserReportCategoryIds;
    return this.http.post<number[]>(this.endpoint + 'UpdateUserCategories', body, { headers, observe: 'response' });
  }

  deleteUserLocation(locationId: number): Observable<any> {
    console.log(locationId);
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = locationId;
    return this.http.post<number>(this.endpoint + 'DeleteUserLocation', body, { headers, observe: 'response' });
  }

  deleteUserReportCategory(userReportCategoryId: number): Observable<any> {
    console.log(userReportCategoryId);
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = userReportCategoryId;
    return this.http.post<number>(this.endpoint + 'DeleteUserReportCategory', body, { headers, observe: 'response' });
  }
  updateUser(updateUser: User): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = updateUser;
    return this.http.post(this.endpoint + 'UpdateUser', body, { headers, observe: 'response' });
  }
  activateUser(userId: number) {
    return this.http.get(this.endpoint + 'ActivateUser?userId=' + userId, { observe: 'response' });
  }
  deactivateUser(userId: number) {
    return this.http.get(this.endpoint + 'DeactivateUser?userId=' + userId, { observe: 'response' });
  }
  editUserTypeAndRole(userId: number, userTypeId: number, newRoleId: number)
  {
    return this.http.get(this.endpoint + 'EditUserTypeAndRole?userId=' + userId + '&userTypeId=' + userTypeId + '&newRoleId=' + newRoleId, { observe: 'response' });    
  }
}



// WEBPACK FOOTER //
// ./src/app/services/registration.service.ts